import { funcState } from '../../utils/funcState';
import { Filters } from '../utils/filtersEnum';
import { asArray } from '../utils/asArray';

const TagFilterProvider = ({ updateFilter }) => {
  const [lastCategoryData, setLastCategoryData] = funcState();
  const [tags, setTags] = funcState([]);
  const [availableTags, setAvailableTags] = funcState([]);

  const update = ({ categoryData, queryParams }) => {
    setLastCategoryData(categoryData);

    const sportTags = categoryData?.sport?.tags ?? [];
    setAvailableTags(sportTags);

    const categoryTag = categoryData?.query?.tag;
    const queryTags = queryParams?.tags ?? [];

    const activeTags = categoryTag ? asArray(categoryTag) : asArray(queryTags);
    const hydratedActiveTags = activeTags
      .map((n) => availableTags.value.find((m) => m.slug === n))
      .filter(Boolean);

    setTags(hydratedActiveTags);

    updateFilter({
      key: Filters.Tag,
      value: { tags: tags.value, availableTags: availableTags.value },
    });
  };

  const toQueryParams = () => {
    return {
      tags: tags.value.map((n) => n.slug),
    };
  };

  const pushHistory = (obj) => {
    const categoryData = lastCategoryData.value;

    if (categoryData?.query?.tag && obj?.tags?.length !== undefined) {
      const nearestSportCat = categoryData.parents.find(
        (n) => n.type === 'Distance',
      );

      if (nearestSportCat) {
        return `/${nearestSportCat.path}`;
      }
    }

    return null;
  };

  const defaultFilters = {
    tags: undefined,
  };

  const hasActiveFilters = () => {
    return tags.value.length > 0;
  };

  return {
    exposed: {},
    update,
    toQueryParams,
    pushHistory,
    hasActiveFilters,
    defaultFilters,
  };
};

export default TagFilterProvider;
